import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ConfiguracoesMiaService} from "../../services/configuracoes-mia.service";

@Component({
  selector: 'app-pedido-origem',
  templateUrl: './pedido-origem.component.html',
  styleUrls: ['./pedido-origem.component.scss']
})
export class PedidoOrigemComponent implements OnInit, OnDestroy {
  @Input() pedido: any  = {}
  usaMiaV3 = false;
  private assinatura: Subscription;

  constructor(private configuracoesMiaService: ConfiguracoesMiaService) { }

  ngOnInit(): void {
    this.assinatura = this.configuracoesMiaService.configuracoes$.subscribe((configuracoes: any) => {
      this.usaMiaV3 = !!(configuracoes && configuracoes.usarMiaV3);
    });
  }

  ngOnDestroy(): void {
    if (this.assinatura) this.assinatura.unsubscribe();
  }

  // Typebot foi aposentado nas lojas com Mia V3: pedido "bot" nessas lojas é da Mia
  get viaMia(): boolean {
    return this.usaMiaV3 && String(this.pedido?.origem || '').toLowerCase() === 'bot';
  }
}
